import React from "react";

import { LimitProps } from "./types";
import { useLimit } from "./hooks";

export const Limit = (props: LimitProps) => {
  const { getLimitsProps, values } = useLimit(props);

  let view;

  switch (values.content) {
    case "desktop":
      view = (
        <div {...getLimitsProps()}>
          <span style={{ color: "#ECEAFF" }}>
            {values.max}&nbsp;{values.balanceLabel}
          </span>
          <span>MAX. ПРОГНОЗ</span>
        </div>
      );
      break;
    case "v3":
      view = (
        <div {...getLimitsProps()}>
          <span>MAX&nbsp;</span>
          <span>
            {values.max}&nbsp;{values.balanceLabel}
          </span>
        </div>
      );
      break;
    default:
      view = null;
      break;
  }

  return view;
};
